import {
  Box, Button, Flex, Icon, Tab, TabIndicator, TabList, useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import { BsFillFloppyFill, BsEye } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { useUpdateFormMutation } from '../../Services/apiSlice';
import useFormDraft from '../../helpers/useFormDraft';

const tabProps = {
  variant: 'outline',
  size: 'sm',
  px: '1',
  mx: '1',
  fontSize: 'sm',
  _selected: { color: 'blue.700', fontWeight: 'bold' },
};

const EditMenu = () => {
  const variantChange = '0.2s linear';
  const sidebarMargins = '0px';
  const sidebarRadius = '10px';
  const sidebarBg = useColorModeValue('white', 'navy.800');
  const { isFetching, data: form } = useFormDraft();
  const [updateForm, { isLoading }] = useUpdateFormMutation();
  const toast = useToast();

  const handleSave = async () => {
    const rta = updateForm(form).then(({ error }) => { if (error) { console.log(error); throw new Error(error.data?.error); } });

    toast.promise(rta, {
      success: {
        title: 'Changes saved successfully', isClosable: true, variant: 'left-accent', duration: 2000,
      },
      error: {
        title: 'Ocurrió un error al guardar los cambios',
        variant: 'left-accent',
        position: 'top',
        isClosable: true,
      },
      loading: { title: 'Please wait...', position: 'top' },
    });
  };

  return (
    <Box display="block" position="sticky" zIndex="1" w="100%" top="0">
      <Flex
        bg={sidebarBg}
        transition={variantChange}
        // w="100%"
        mb={{
          sm: '16px',
        }}
        h="40px"
        py="4px"
        px="8px"
        m={sidebarMargins}
        filter="drop-shadow(0px 5px 14px rgba(0, 0, 0, 0.05))"
        borderRadius={sidebarRadius}
        justify="space-between"
        boxShadow="10px 5px 14px rgba(0, 0, 0, 0.15)"
      >
        <TabList my="2px" color="gray.700">
          <Tab {...tabProps}>
            Setup
          </Tab>
          <Tab {...tabProps}>
            Fields
          </Tab>
          <Tab {...tabProps}>
            End page
          </Tab>
          <Tab {...tabProps}>
            Actions
          </Tab>
          <Tab {...tabProps}>
            Publish
          </Tab>
        </TabList>
        <TabIndicator height="2px" bg="blue.500" borderRadius="1px" bottom="6px" />
        <Box display="flex" gap="2">
          <Button
            as={Link}
            to="preview"
            leftIcon={<Icon as={BsEye} />}
            colorScheme="blue"
            variant="outline"
            size="sm"
          >
            Preview
          </Button>
          <Button
            leftIcon={<Icon as={BsFillFloppyFill} />}
            colorScheme="blue"
            variant="solid"
            size="sm"
            onClick={handleSave}
            isDisabled={isFetching || isLoading}
          >
            Save
          </Button>
        </Box>
      </Flex>
    </Box>

  );
};

export default EditMenu;
